import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, providersCasino, profile, countries } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive layout identifier
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange', // CSS class for styling
                            readonly: true, // Make the input read-only
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true, // Return date as a string
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar', // Suggestion type
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for user type selection
                            name: 'TypeUser',
                            localId: 'provider:combo', // Local ID for the component
                            label: _('Tipo Usuario'), // Label for the dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the dropdown
                                { id: '0', value: _('Concesionario') },
                                { id: '1', value: _('Subconcesionario') },
                                { id: '4', value: _('Subconcesionario 2') },
                                { id: '2', value: _('Punto de Venta') },
                                { id: '3', value: _('Afiliado') },
                            ],
                        },
                        {
                            view: 'combo', // Combo box for BetShop selection
                            name: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label with icon
                            hidden: !devConfig.getPermAction(
                                // Conditional visibility based on permissions
                                'filterByBetShop',
                                'Add',
                            ),
                            css: 'prm-filterByBetShop', // CSS class for styling
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch data for the combo box
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse the response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Populate the combo box with data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive layout identifier
                    cols: [
                        {
                            view: 'radio', // Radio buttons for report type selection
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Label for the radio group
                            labelPosition: 'top',
                            minWidth: 200,
                            height:
                                screen.width < 500 || screen.height < 500
                                    ? 90 // Adjust height based on screen size
                                    : 0,
                            value: 0, // Default selected value
                            options: [
                                { id: 1, value: _('Totales') },
                                { id: 0, value: _('Detallado') },
                            ],
                        },
                        {
                            view: 'radio', // Radio buttons for commission selection
                            name: 'MyCommission',
                            label: _('Mi comisión'), // Label for the radio group
                            labelPosition: 'top',
                            value: 2, // Default selected value
                            options: [
                                { id: 1, value: _('Sí') },
                                { id: 2, value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the dropdown
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Conditional visibility based on configuration
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Dropdown for country selection (readonly)
                            name: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Make the dropdown read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the dropdown
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Conditional visibility based on configuration
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry country-hide', // CSS classes for styling
                        },
                        {
                            view: 'richselect', // Dropdown for commission payment type selection
                            name: 'ComissionsPayment',
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility based on partner selection
                            label: _('Pago de comisiones'), // Label for the dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'S', value: _('Saldo') },
                                { id: 'F', value: _('Factura') },
                            ],
                        },
                        { id: 'grav', gravity: 1 }, // Gravity for layout management
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include the left section in the layout
                },
            ],
        };
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clear the form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    width: 110,
                    id: 'consultDesk', // Button ID
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            // Trigger filter event with data
                            filterdata,
                        ]);
                        $$('b5').collapse(); // Collapse the accordion section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'), // Button label
                    click: () => {
                        $$('myForm2').clear(); // Clear the form values
                    },
                },
                {
                    view: 'button', // Button to submit the second form
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if applicable
                            }
                        }
                        this.app.callEvent('depositReport:filter', [
                            // Trigger filter event with data
                            filterdata,
                        ]);
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide', // Accordion type
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initial state of the accordion
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5', // ID for the section
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the accordion section
            scroll: 'xy', // Enable both horizontal and vertical scrolling
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true, // Allow moving the window
            id: 'filterPopup', // ID for the popup
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the toolbar
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2', // ID for the form
                type: 'clean', // Clean type for styling
                rows: [accordion_section3, buttons2], // Include accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            view: 'form', // Main form for the view
            type: 'clean', // Clean type for styling
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get the current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input if applicable
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
